export default "__VITE_ASSET__DLh49_iL__"